// assets
import AllQuestionsIcon from 'Components/Icons/AllQuestionsIcon';
import FaqIcon from 'Components/Icons/FaqIcon';
import ResponseIcon from 'Components/Icons/ResponseIcon';
import TeamIcon from 'Components/Icons/TeamIcon';
//const icons = { IconUsers };

const pages = {
    id: 'pages',
    title: 'Pages',
    type: 'group',
    children: [
        {
            id: 'faq',
            title: "Our FAQ's",
            type: 'item',
            url: '/dashboard/faq',
            icon: AllQuestionsIcon,
            breadcrumbs: false
        },
        {
            id: 'question-registry', //donot change this or it will have effects in Sidebar.js
            title: 'Question registry',
            type: 'item',
            url: '/dashboard/question-registry',
            // icon: ResponseIcon,
            icon: FaqIcon,
            breadcrumbs: false
        },
        {
            id: 'my-team',
            title: 'My team',
            type: 'item',
            url: '/dashboard/my-team',
            icon: TeamIcon,
            breadcrumbs: false
        }
    ]
};

export default pages;
